import { CalendarDate } from "./calendar-date";
import { defaultClosedPaidDuration } from "./tenant";
export const closedStatusCategoryKey = "Closed";
export const closedStatusWindowStart = (closedPaidDuration) => CalendarDate.today.addDays(-(closedPaidDuration ?? defaultClosedPaidDuration));
//# sourceMappingURL=closed-status-window.js.map